import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

const API_BASE = API_BASE_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const tokenWithoutQuotes = token ? token.replace(/"/g, "") : "";

  return {
    Authorization: tokenWithoutQuotes ? `Bearer ${tokenWithoutQuotes}` : "",
  };
};

const cleanParams = (params = {}) =>
  Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});

const get = (path, params) =>
  axios
    .get(`${API_BASE}${path}`, {
      params: cleanParams(params),
      headers: getAuthHeaders(),
    })
    .then((response) => response.data);

export const getIntegrationLogs = (params) =>
  get("/integration/logs", params);

export const getIntegrationLogsSummary = (params) =>
  get("/integration/logs/summary", params);

export const getIntegrationLogHistory = (params) =>
  get("/integration/logs/history", params);

export const getWebhookOutboxLogs = (params) =>
  get("/integration/webhook-outbox", params);

export const retryWebhookOutbox = (body) =>
  axios
    .post(`${API_BASE}/integration/webhook-outbox/retry`, body, {
      headers: getAuthHeaders(),
    })
    .then((response) => response.data);

export const retryWebhookOutboxById = (id) =>
  axios
    .post(
      `${API_BASE}/integration/webhook-outbox/${encodeURIComponent(
        id,
      )}/retry`,
      {},
      {
        headers: getAuthHeaders(),
      },
    )
    .then((response) => response.data);
